import React from "react";
import { Space, Row, Col, Tree, Button } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import withRouter from "../withRouter";
import AssignVehiclesToGeofenceStore from "../store/AssignVehiclesToGeofenceStore";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import backgroundImage from "../assets/images/Kiosk/cabBooking-bg.jpg";
import logo from "../assets/images/Kiosk/omanlogo.png";
import "../kioskLandingPage.css";
import config from "../config.js";

class KioskLandingPage extends React.Component {
  constructor(props, context) {
    super(props);
    this.cookies = new Cookies();
  }
  updateDashboard = (value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;
    console.log(decodedCookieData, "decoded cookidata");
    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    this.setState({ update: 1 });
  };

  render() {
    const encodedCookieData = this.cookies.get("data");

    // Step 2: Decode the data (if needed)
    const isIaunchingDashboard = JSON.parse(
      base64_decode(encodedCookieData)
    ).showLaunchingDashboard;

    return (
      <>
        <div
          className="landing-container"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="landing-overlay">
            <div className="header">
              <img
                // src={require("../assets/images/" + config.innerLogo)}
                src={require("../assets/images/Kiosk/TrackeazyLogo.png")}
                alt="Logo"
                className="kiosklogo"
              />
            </div>

            <h2>Welcome to</h2>
            <h1> Kiosk Booking</h1>

            <button
              className="cta-button"
              //   onClik={() => {
              //     console.log("first");
              //     this.props.navigate("/bookinglist");
              //   }}
              onClick={async () => {
                console.log("first");

                this.props.navigate("/bookinglist");
                this.updateDashboard(0);
                // await this.cookies.set("showLaunchingDashboard", 0);
              }}
            >
              Book Your Taxi Now
            </button>

            <p className="powered-text">Powered by TrackEazy</p>
          </div>
        </div>
      </>
    );
  }
}
KioskLandingPage.contextType = StoreContext;
export default observer(withRouter(KioskLandingPage));
